export interface UtcTimeWindow {
  startHour: number;
  startMinute: number;
  endHour: number;
  endMinute: number;
}

// Approximate open/close transition windows, in literal UTC — no timezone/DST math.
// Bracket the real KSA-converted open (10:00 KSA = 07:00 UTC) and close (15:00 KSA = 12:00 UTC).
export const MARKET_OPEN_TRANSITION_WINDOW_UTC: UtcTimeWindow = {
  startHour: 6,
  startMinute: 30,
  endHour: 7,
  endMinute: 30,
};

export const MARKET_CLOSE_TRANSITION_WINDOW_UTC: UtcTimeWindow = {
  startHour: 11,
  startMinute: 30,
  endHour: 12,
  endMinute: 30,
};
